module.exports = {
      id: "arrow-right-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#arrow-right-icon",
      toString: function () {
        return this.url;
      }
    }